import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserPermission } from 'constants/user.constants';
import { getTerms, getUserPermission } from 'state/reducers/user.reducers';

export interface ISystemMessage {
	id: number;
	iconType: string;
	titleKey: string;
	contentKey: string;
}

interface State {
	queue: ISystemMessage[];
	currentIndex: number;
	errorKey: string | null;
}

const initialState: State = {
	queue: [],
	currentIndex: 0,
	errorKey: null,
};

const slice = createSlice({
	name: 'systemMessages',
	initialState,
	reducers: {
		setQueue: (state, action: PayloadAction<ISystemMessage[]>) => {
			state.queue = action.payload;
			state.currentIndex = 0;
			state.errorKey = null;
		},
		advanceQueue: (state) => {
			state.currentIndex = Math.min(state.currentIndex + 1, state.queue.length);
		},
		setErrorKey: (state, action: PayloadAction<string | null>) => {
			state.errorKey = action.payload;
		},
	},
});

export const { setQueue, advanceQueue, setErrorKey } = slice.actions;

const queueSelector = (state: { systemMessages: State }) => state.systemMessages.queue;
const indexSelector = (state: { systemMessages: State }) => state.systemMessages.currentIndex;

export const getSystemMessageQueue = queueSelector;
export const getSystemMessageIndex = indexSelector;
export const getSystemMessageError = (state: { systemMessages: State }) => state.systemMessages.errorKey;

export const getCurrentSystemMessage = createSelector(
	[queueSelector, indexSelector],
	(queue: ISystemMessage[], currentIndex: number) => queue[currentIndex] ?? null
);

export const getShouldShowSystemMessageModal = createSelector(
	[getUserPermission, getTerms, getCurrentSystemMessage, getSystemMessageError],
	(userPermission, terms, current, errorKey) =>
		userPermission !== UserPermission.NONE &&
		terms === true &&
		(current !== null || errorKey !== null)
);

export default slice.reducer;
